export default "__VITE_ASSET__508c9870__"